module.exports = __webpack_public_path__ + "img/logo.be31b288.svg";